<template>
  <div class="result-form-box-list">
    <!--ocr识别字段-content-->
    <div v-for="item in analysisList" style="flex-grow: 1">
      <div style="display: block; position: relative;">
        <!--PO号码-->
        <div class="form-title">{{ $t('SeaExport.PONumber') }}</div>
        <el-input v-model="item.poNo" :disabled="true" />
        <div class="form-title">{{ $t('SeaExport.MaterialInformation') }}</div>
        <div>
          <el-table :data="item.goodsDetails" height="100%" border>
            <el-table-column :label="$t('SeaExport.MaterialNumber')" width="120">
              <template v-slot="scope">
                <span>{{ scope.row.materialCode }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('SeaExport.HsCode2')" width="120">
              <template v-slot="scope">
                <span>{{ scope.row.hsCode }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('SeaExport.itemCount')" width="80">
              <template v-slot="scope">
                <span>{{ scope.row.quantity }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('SeaExport.NetWeightKg')" width="80">
              <template v-slot="scope">
                <span>{{ scope.row.netWeight }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('SeaExport.ChineseDescriptionOfGoods')" width="200">
              <template v-slot="scope">
                <span>{{ scope.row.chineseDescription }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('SeaExport.EnglishCommodityName')" width="200">
              <template v-slot="scope">
                <span>{{ scope.row.englishDescription }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('SeaExport.Package')" width="80">
              <template v-slot="scope">
                <span>{{ scope.row.packing }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ResultFormBoxList',
  components: { },
  props: {
    index: { type: Number, default: 0 },
    resultArray: { type: Array, default: () => [] }
  },
  data() {
    return {
      analysisList: []
    }
  },
  watch: {
    showAll(val, oldVal) {
      if (val !== oldVal) {
        this.showCurrentOcrRecognitionFields()
      }
    },
    index(val, oldVal) {
      if (val !== oldVal) {
        this.refreshList()
      }
    }
  },
  async created() {
    await this.refreshList()
  },
  methods: {
    async refreshList() {
      const list = []
      const resultJson = this.resultArray[this.index].text.data
      const row = this.convertChineseKeysToEnglish(resultJson)
      list.push({ ...row })
      this.analysisList = list
    },
    convertChineseKeysToEnglish(jsonData) {
      const keyMappings = {
        '唛头': 'mark',
        'PO NO': 'poNo',
        '货物明细': 'goodsDetails',
        '件数': 'quantity',
        'HS CODE': 'hsCode',
        '中文品名': 'chineseDescription',
        '净重': 'netWeight',
        '包装': 'packing',
        '物料号': 'materialCode',
        '英文品名': 'englishDescription'
      }

      const result = {}
      for (const [key, value] of Object.entries(jsonData)) {
        const englishKey = keyMappings[key] || key

        if (Array.isArray(value)) {
          result[englishKey] = value.map(item => {
            const newItem = {}
            for (const [itemKey, itemValue] of Object.entries(item)) {
              const englishItemKey = keyMappings[itemKey] || itemKey
              newItem[englishItemKey] = itemValue
            }
            return newItem
          })
        } else {
          result[englishKey] = value
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.result-form-box-list {
  display: flex;
  .form-title {
    font-size: 15px;
    font-weight: bold;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 2px;
  }
  .centered-cell {
    text-align: center; /* 文字居中对齐 */
    width: 15%;
  }
}
</style>
